/**
 * Configuration des onglets de l'interface d'administration
 * @module admin/constants/tabConfig
 */

/**
 * Labels affichés pour chaque onglet
 * @type {Object.<string, string>}
 */
export const TabLabels = {
  'twitch-cli': 'Twitch CLI',
  'command-test': 'Test Commandes',
  'rewards-test': 'Test Récompenses',
  'database': 'Base de données',
  'integrations': 'Intégrations',
  'tokens': 'Tokens',
  'logs': 'Logs',
  'health': 'Santé',
  'users': 'Utilisateurs',
  'birthdays': 'Anniversaires',
  'application': 'Application',
  'premium-features': 'Freemium',
};

/**
 * Onglet actif par défaut
 * @type {string}
 */
export const DEFAULT_TAB = 'twitch-cli';

/**
 * Liste de tous les onglets disponibles
 * @type {string[]}
 */
export const ALL_TABS = Object.keys(TabLabels);
